import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {User} from './models/user.model';
import {Observable} from 'rxjs';
import {UserDetailService} from './service/user-detail.service';

@Injectable()
export class UserResolve  {

  constructor(
    private userDetailService: UserDetailService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot): User | Observable<User> {
    return this.userDetailService.getUserById(route.params['id']);
  }
}
